<template>
    <div>
        <div style="display: flex; flex-direction: row">
            <template v-if="multiple">
                <v-autocomplete
                    :readonly="readonly"
                    @update:search-input="SearchAlbaran"
                    v-model="items"
                    :items="albaranes"
                    item-text="nro"
                    item-value="id"
                    :label="label"
                    :outlined="outlined"
                    :rules="rules"
                    multiple
                    chips
                    deletable-chips
                    small-chips
                    clearable
                >
                    <template v-slot:append-item>
                        <div v-intersect="endIntersect" />
                    </template>
                    <template v-slot:selection="data">
                        <v-chip
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            close
                            @click:close="remove(data.item)"
                        >
                            <router-link
                                :to="`guardar-orden?id=${data.item.id}`"
                                target="_blank"
                            >
                                {{ data.item.nro }}</router-link
                            >
                        </v-chip>
                    </template>
                </v-autocomplete>
            </template>
            <template v-else>
                <v-autocomplete
                    :readonly="readonly"
                    @update:search-input="SearchAlbaran"
                    v-model="id_albaran"
                    :items="albaranes"
                    item-text="nro"
                    item-value="id"
                    :label="label"
                    :outlined="outlined"
                    :rules="rules"
                >
                    <template v-slot:append-item>
                        <div v-intersect="endIntersect" />
                    </template>
                    <template v-slot:selection="data">
                        <v-chip
                            small
                            v-bind="data.attrs"
                            :input-value="data.selected"
                        >
                            <router-link
                                :to="`guardar-orden?id=${data.item.id}`"
                                target="_blank"
                            >
                                {{ data.item.nro }}</router-link
                            >
                        </v-chip>
                    </template>
                </v-autocomplete>
            </template>
        </div>
    </div>
</template>
<script>
import { debounce } from "../../helpers";

export default {
    props: [
        "value",
        "extra",
        "label",
        "item-text",
        "enabled",
        "outlined",
        "rules",
        "multiple",
        "readonly",
    ],
    data() {
        return {
            creado: null,
            id_albaran: null,
            orden: {},
            dialog: false,
            users: [],
            update: false,
            selectedAlbaranes: [],
        };
    },
    watch: {
        value(val) {
            if (this.multiple) {
                this.selectedAlbaranes = val;
            } else {
                this.id_albaran = val;
            }
        },
        id_albaran(val) {
            this.$emit("input", val);
        },
        // Observa cambios en el array de órdenes seleccionadas
        selectedAlbaranes(newAlbaranes) {
            // console.log("newAlbaranes:", newAlbaranes);
            this.$emit("input", newAlbaranes);
        },
    },
    methods: {
        SearchAlbaran: debounce(function (val) {
            this.$store.dispatch("searchAlbaranVenta", val);
        }, 500),
        endIntersect(entries, observer, isIntersecting) {
            if (isIntersecting) {
                this.$store.dispatch("getAlbaranVentaNext", this);
            }
        },
        remove(item) {
            const index = this.items.indexOf(item.id);
            if (index >= 0) this.items.splice(index, 1);
            if (index >= 0) this.selectedAlbaranes.splice(index, 1);
            console.log("items despues de eliminar", this.items);
            console.log(
                "selectedAlbaranes despues de eliminar",
                this.selectedAlbaranes
            );
        },
    },
    mounted() {
        this.$store.dispatch("getAlbaranVenta");
        if (this.value != null) {
            if (this.multiple) {
                this.selectedAlbaranes = this.value;
            } else {
                this.id_albaran = this.value;
            }
        }
        // this.getAgente();
    },
    computed: {
        items: {
            get: function () {
                return this.selectedAlbaranes.map((element) => {
                    return element.id_orden_relacionada;
                });
            },
            set: function (val) {
                this.selectedAlbaranes = val.map((element) => {
                    return {
                        id: null,
                        id_orden_relacionada: element,
                    };
                });
            },
        },
        albaranes() {
            ///console.log("siva");
            let albaranes_temp = this.$store.getters.getalbaranVenta;
            if (this.extra != null) {
                albaranes_temp = albaranes_temp.concat(this.extra);
            }
            if (this.creado) {
                albaranes_temp.push(this.creado);
            }
            // console.log(albaranes_temp);
            return albaranes_temp;
        },
    },
};
</script>
